export interface Agent {
  id: number;
  user_id: number;
  name: string;
  is_main: number;
  personality_type: string;
  communication_style: string;
  core_values: string;
  boundaries: string;
  proactivity_level: string;
  goal_work_guidelines: string;
  full_markdown: string | null;
  model: string;
  provider: string | null;
  max_tokens: number;
  color: string;
  avatar_mime_type: string | null;
  company_id: number | null;
  role: string | null;
  allowed_tools: string;
  allowed_persons: string;
  allowed_skills: string;
  created_at: string;
  updated_at: string;
}

export interface AgentSummary {
  id: number;
  name: string;
  is_main: number;
  personality_type: string;
  model: string;
  color: string;
  has_avatar: boolean;
}

export interface CreateAgentRequest {
  name: string;
  personality_type?: string;
  communication_style?: string;
  core_values?: string;
  boundaries?: string;
  proactivity_level?: string;
  goal_work_guidelines?: string;
  full_markdown?: string | null;
  model?: string;
  provider?: string;
  max_tokens?: number;
  color?: string;
}

export const STRATEGY_STATE_LABELS: Record<string, string> = {
  goal_received: 'Ziel erhalten',
  clarifying: 'Rueckfragen',
  ready: 'Bereit',
  strategizing: 'Strategieentwicklung',
  strategy_review: 'Strategie-Review',
  executing: 'Ausfuehrung',
  blocked: 'Blockiert',
  reporting: 'Berichterstellung',
  completed: 'Abgeschlossen',
  failed: 'Fehlgeschlagen',
};

export interface UpdateAgentRequest {
  name?: string;
  personality_type?: string;
  communication_style?: string;
  core_values?: string;
  boundaries?: string;
  proactivity_level?: string;
  goal_work_guidelines?: string;
  full_markdown?: string | null;
  model?: string;
  provider?: string;
  max_tokens?: number;
  color?: string;
}

export interface ProviderInfo {
  id: string;
  displayName: string;
  command: string;
}
